import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  PreloadAllModules,
  provideRouter,
  Router,
  withInMemoryScrolling,
  withPreloading,
  // withViewTransitions,
} from "@angular/router";
import * as Sentry from "@sentry/angular";

import {
  BrowserModule,
  provideClientHydration,
  withEventReplay,
  withNoIncrementalHydration,
} from "@angular/platform-browser";
import { environment } from "src/environments/environment";

import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { ServiceWorkerModule } from "@angular/service-worker";
import { FormsModule } from "@angular/forms";

import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { StoreRouterConnectingModule } from "@ngrx/router-store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { NgxSafePipesModule } from "@it-era/ngx-safe-pipes";
import { NgxSsrCacheModule } from "@ngx-ssr/cache";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { provideToastr } from "@iqx-limited/ngx-toastr";
import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from "ngx-google-analytics";


import { CoreModule } from "./core/core.module";
import { routes } from "./app.routes";

import { reducers } from "./store/reducers";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({
        anchorScrolling: "enabled",
        scrollPositionRestoration: "enabled",
      }),
    ),

    provideClientHydration(withEventReplay(), withNoIncrementalHydration()),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    ...(environment.production
      ? [
          {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
              showDialog: false,
            }),
          },
          {
            provide: Sentry.TraceService,
            deps: [Router],
          },
        ]
      : []),

    provideToastr({
        progressBar: true,
        tapToDismiss: true,
        progressAnimation: "decreasing",
    }),

    importProvidersFrom([
      BrowserModule,
      ServiceWorkerModule.register("ngsw-worker.js", {
        enabled: environment.production,
      }),
      CommonModule,
      FormsModule,
      NgxSafePipesModule,
      FontAwesomeModule,
      CoreModule.forRoot(),
      StoreModule.forRoot(reducers),
      EffectsModule.forRoot([]),
      StoreRouterConnectingModule.forRoot({
        stateKey: "router",
      }),
      !environment.production
        ? StoreDevtoolsModule.instrument({ connectInZone: false })
        : [],
      NgxGoogleAnalyticsModule.forRoot("UA-85020541-2"),
      NgxGoogleAnalyticsRouterModule,
      NgxSsrCacheModule.configLruCache({ maxAge: 10 * 60000, maxSize: 50 }),
    ]),
  ],
};
